// extracted by mini-css-extract-plugin
module.exports = {"dateItem":"requirementdashboardrow_dateItem__2qtJS"};